import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import { AccountContext } from "auth/accountProvider";

const greetingKey = (hour: number): string => {
  if (hour < 12) return "dashboard.goodMorning";
  if (hour < 18) return "dashboard.goodAfternoon";
  return "dashboard.goodEvening";
};

interface DashboardHeroProps {
  period: { start: Date; end: Date };
}

const DashboardHero: FC<DashboardHeroProps> = ({ period }) => {
  const { t } = useTranslation();
  const { userInfo } = useContext(AccountContext);
  const name = userInfo.givenName || "";
  const greeting = t(greetingKey(new Date().getHours()));

  return (
    <div className="overview-hero">
      <div>
        {userInfo.logoUrl && (
          <img
            className="overview-hero__logo"
            src={userInfo.logoUrl}
            alt={userInfo.organization}
          />
        )}
        <h1 className="overview-hero__greeting">
          {name ? `${greeting}, ${name}` : greeting}
        </h1>
        <p className="overview-hero__sub">{t("dashboard.heroSub")}</p>
      </div>
      <span className="overview-hero__period">
        {format(period.end, "yyyy")} {t("dashboard.soFar")}
        <span className="overview-hero__period-range">
          {" · "}
          {format(period.start, "MMM")}–{format(period.end, "MMM")}
        </span>
      </span>
    </div>
  );
};

export default DashboardHero;
